import Vue from "vue";
import VueRouter from "vue-router";
 
// 引入组件
// import head from "../components/head";
// const index = r => require.ensure([], () => r(require('../pages/index')), 'index');
// const Policymanagement = r => require.ensure([], () => r(require('../views/Policymanagement')), 'Policymanagement');
// const TemplateManagement = r => require.ensure([], () => r(require('../views/TemplateManagement')), 'TemplateManagement');
import Policymanagement from '../views/Policymanagement'
import TemplateManagement from '../views/TemplateManagement'
// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter);

const routes = [{
	path: "/views/Policymanagement",
	component: Policymanagement
},
{
	path: "/views/TemplateManagement",
	component: TemplateManagement
},
// 重定向
{
	path: '/',
	redirect: '/views/Policymanagement'
}
]
console.log('routes', routes)
var router = new VueRouter({
	routes
})
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js


// WEBPACK FOOTER //
// ./src/router/index.js